// Client-side image conversion. HEIC/HEIF is decoded with libheif (WASM, loaded
// lazily from the bundle — no network); everything else goes through a canvas.

export const FORMATS = {
  jpg: { mime: 'image/jpeg', ext: 'jpg', label: 'JPG' },
  png: { mime: 'image/png', ext: 'png', label: 'PNG' },
};

export const isHeicName = (name = '') => /\.(heic|heif)$/i.test(name);

export function outputName(name, format) {
  const base = name.replace(/\.[^./\\]+$/, '') || 'image';
  return `${base}.${FORMATS[format].ext}`;
}

async function canvasConvert(file, mime, quality) {
  const bitmap = await createImageBitmap(file);
  const canvas = document.createElement('canvas');
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const ctx = canvas.getContext('2d');
  if (mime === 'image/jpeg') { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height); }
  ctx.drawImage(bitmap, 0, 0);
  if (bitmap.close) bitmap.close();
  return new Promise((resolve, reject) =>
    canvas.toBlob(b => (b ? resolve(b) : reject(new Error('Could not encode image'))), mime, quality));
}

// quality is 0–1 and only applies to JPEG.
export async function convertImage(file, format, quality = 0.92) {
  const { mime } = FORMATS[format];
  if (isHeicName(file.name) || /image\/hei[cf]/i.test(file.type)) {
    const { heicTo } = await import('heic-to');
    return heicTo({ blob: file, type: mime, quality });
  }
  return canvasConvert(file, mime, quality);
}
